import { render, staticRenderFns } from "./workcenter-repair.vue?vue&type=template&id=5491bd68&scoped=true&"
import script from "./js/workcenter-repair.js?vue&type=script&lang=js&"
export * from "./js/workcenter-repair.js?vue&type=script&lang=js&"
import style0 from "./workcenter-repair.vue?vue&type=style&index=0&id=5491bd68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5491bd68",
  null
  
)

export default component.exports